export function menuProductCard() {

  const events = () => {
    const menuProductCard = document.querySelector('.section_menu');
		const menuProductCardOffsetTop = menuProductCard.offsetTop;
    const eventsOnScroll = () => {
			
      if(window.scrollY > (menuProductCardOffsetTop - 79)) {
        (!menuProductCard.classList.contains('scrolled')) ? menuProductCard.classList.add('scrolled') : '' ;

     
      } else {
        (menuProductCard.classList.contains('scrolled')) ? menuProductCard.classList.remove('scrolled') : '' ;

       
      }
    };
		//run events
		window.addEventListener('scroll', eventsOnScroll);
	}
	
  events(); 
  
}